<template>
    <b-modal id="decommissionModal" title="Are you sure?" v-model="value" v-if="value" :no-close-on-backdrop=" true " @close=" close ">
        <b-container fluid>
            <b-row>
                <b-col>
                    <h4 class="mb-4">Are you sure you wish to deactivate {{ username }}?</h4>
                    <b-form-group label="Reason" label-for="reason">
                        <b-form-input
                            id="reason"
                            name="reason"
                            type="text"
                            v-model="reason"
                            required
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>
        <div slot="modal-footer">
            <b-btn variant="default" @click="close()">Cancel</b-btn>
            <b-btn variant="danger" @click="confirm()">Yes</b-btn>
        </div>
    </b-modal>
</template>

<script>
export default {
    props: {
        'user': Object,
        'value': Boolean,
    },

    data: () => ({
        busy: false,
        reason: '',
    }),

    computed: {

        username(){

            return this.user.name || this.user.firstname;
        }
    },

    methods: {
        confirm() {
          if(this.reason == '') {
            alert('Reason is required');
          }
          else {
            this.$emit('confirm', this.reason);
            this.$emit('input', false);
          }
        },

        close() {
            this.$emit('input', false);
        }
    },
}
</script>
